function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("image", {
  id: "image0",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAACBjSFJN\nAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAGFBMVEUAAAAoMDglMTggMDgm\nMjgmMTgmMjj///85wUqBAAAABnRSTlMAIL8g39/C9yYsAAAAAWJLR0QHFmGI6wAAAAlwSFlzAAAL\nEwAACxMBAJqcGAAAAAd0SU1FB+QBFhEqNS0vE4sAAABaSURBVBjTY2CgHDAqg0ghAzCHKQVIM7op\nQGTCnBkYRFIhMgyiKQaMbsEwTWHOcAmQFFwCJIWQABqVguCIpIIMhEkEi8KlgEYxwqTAdsCkmEBG\nMYYpYDqUMgAAs+oOVZvMXb4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMDEtMjJUMTc6NDI6NTMr\nMDM6MDC3D6yIAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTAxLTIyVDE3OjQyOjUzKzAzOjAwxlIU\nNAAAAABJRU5ErkJggg=="
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/delete.cccc1dc4.svg";
export { SvgComponent as ReactComponent };